import * as React from "react";
import { SVGProps, memo } from "react";
const SvgFilterDefaultState = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="1.06 1 9.89 10"
    role="img"
    {...props}
  >
    <path
      d="M6.5 5.178 9.942 2H2.058L5.5 5.178V10h1V5.178Zm-2 .437-3.12-2.88C.71 2.117 1.146 1 2.057 1h7.884c.91 0 1.348 1.117.679 1.735L7.5 5.615V10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V5.615Z"
      fill="#666"
      fillRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgFilterDefaultState);
export default Memo;
